module.exports = __webpack_public_path__ + "static/order-list-20a0804453a9718c8752ed1036399318.png";